module.exports = __webpack_public_path__ + "img/lake-cabin-14.052661ce.jpg";